export default __webpack_public_path__ + "static/media/bed.a98e1d57.svg";